class AlarmController {
  constructor() {
    this.model = undefined;
  }

  $onChanges(changes) {
    if (changes && changes.series) {
      this.series = (this.series || []).filter(
        serie => !(this.off && serie.disabledWhenOff) && serie.value === serie.errorState
      );
    }
  }
}

export default {
  template: require('./alarms.html'),
  restrict: 'E',
  controller: AlarmController,
  controllerAs: 'vm',
  bindings: {
    series: '<',
    off: '<'
  }
};
